import UserManagement from './UserManagement';
import './UserManagement.scss';

export default UserManagement;
